<template>
  <div>
    <div class="h-sm"></div>
    <div id="mobile-navigation" class="block fixed inset-x-0 bottom-0 z-30 bg-transparent px-2 pt-1.5 pb-2 text-gray-dark text-xs">
      <div class="container flex justify-stretch md:justify-between bg-navbar backdrop-blur-sm rounded-xl px-2">
        <router-link :to="{name: 'dashboard'}"
                     class="text-center justify-center items-center w-full pt-2 pb-2 inline-block space-y-1">
          <div><i class="fa-light fa-chart-line text-md 2xl:text-lg"></i></div>
        </router-link>
        <router-link :to="{name: 'customers.index'}"
                     class="text-center justify-center items-center w-full pt-2 pb-2 inline-block space-y-1">
          <div><i class="fa-light fa-users text-md 2xl:text-lg"></i></div>
        </router-link>
        <router-link :to="{name: 'orders.index'}"
                     class="text-center justify-center items-center w-full pt-2 pb-[1.2rem] inline-block space-y-1">
          <div><i class="fa-light fa-cart-shopping text-md 2xl:text-lg"></i></div>
        </router-link>
        <router-link :to="{name: 'products.index'}"
                     class="text-center justify-center items-center w-full pt-2 pb-2 inline-block space-y-1">
          <div><i class="fa-light fa-shop text-md 2xl:text-lg"></i></div>
        </router-link>
        <router-link :to="{name: 'menu'}"
                     class="text-center justify-center items-center w-full pt-2 pb-2 inline-block space-y-1">
          <div><i class="fa-light fa-bars text-md 2xl:text-lg"></i></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navbar"
}
</script>

<style scoped>

</style>
